import { createMuiTheme } from '@material-ui/core/styles';
import { TYPOGRAPHY } from '../theme-config/themeConstants';

// const defaultTheme = createMuiTheme();

const theme = createMuiTheme({
    typography: TYPOGRAPHY,
    palette: {
        primary: {
            main: '#FF5733',
            heather: '#493553',
            heather80: '#6D5D75',
            sunset: '#DD1D78',
            sunset2: '#dd1d77',
            sunset30: '#9B1454',
            white: '#FFFFFF',
            black: '#000000',
            success: '#43B02A',
            error: '#E40046',
            gray100: '#FBFBFC',
            gray200: '#F6F5F6',
            gray250: '#EDEBEE',
            gray300: '#DBD7DD',
            gray400: '#C8C2CB',
            gray500: '#B6AEBA',
            gray550: '#888B8D',
            gray600: '#A49AA9',
            gray700: '#928698',
            gray800: '#807286',
            gray900: '#64536D',
            gray950: '#5B4964',
            gray1000: '#523F5C',
            borderColor: '#E0E0E0',
            backgroundColor: '#F5EBDA80',
            backgroundColor2: '#F5EBDA',
            backgroundColor3: '#EDEBEE',
            boxShadow1Lite: '#d111c91f',
            boxShadow1Medium: '#d111c924',
            boxShadow1Dark: '#d111c933',
            boxShadow1Darkest: '#d111c966',
            boxShadow2Lite: '#888b8d1f',
            boxShadow2Medium: '#888b8d24',
            boxShadow2Dark: '#888b8d33',
            boxShadow3: '#ffffff00',
            boxShadow3Lite: '#ffffff9e',
            boxShadow3Medium: '#ffffffcc',
            boxShadow3Dark: '#ffffffe6',
            boxShadow4: '#00000000',
            boxShadow4Lite: '#00000033',
            boxShadow4Medium: '#0000004d',
            boxShadow4Dark: '#000000b3',
            midNightBlue: '#003380',
        },
    },
    overrides: {
        MuiOutlinedInput: {
            root: {
                fontSize: '16px',
                height: '61px',
                fontFamily: 'eirsans-light !important',
                '@media (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiInput: {
            input: {
                '&::placeholder': {
                    color: 'gray',
                },
                color: 'white', // if you also want to change the color of the input, this is the prop you'd use
            },
        },
        MuiFormControlLabel: {
            label: {
                '@media (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336',
            },
        },
        MuiSelect: {
            icon: {
                color: '#892BA0',
            },
        },
        MuiTextField: {
            root: {
                fontSize: '16px',
                color: 'black',
                '@media (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },

        MuiInputLabel: {
            root: {
                color: 'black',
                fontSize: '16px',
                '@media (min-width:768px) and (max-width: 1024px)': {
                    fontSize: '14px',
                },
                '@media (min-width:322px) and (max-width: 415px)': {
                    fontSize: '12px',
                },
                '@media (min-width:281px) and (max-width: 321px)': {
                    fontSize: '10px',
                },
                '@media (min-width:279px) and (max-width: 280px)': {
                    fontSize: '8px',
                },
            },
            shrink: {
                fontSize: '16px',
                '@media (min-width:320px) and (max-width: 541px)': {
                    fontSize: '14px',
                },
                '@media (min-width:280px) and (max-width: 321px)': {
                    fontSize: '12px',
                },
            },
        },
    },
    largeFont: {
        fontSize: {
            xxxl: '4.95rem',
            xxl: '2.88rem',
        },
    },
});

export default theme;
